import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import { Link } from "react-router-dom";
import { useFormik, FormikProvider, Field } from "formik";
import React, { useState } from "react";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import HousingService from "../../../Services/HousingService";
import { Form, Table } from "react-bootstrap";
import moment from "moment-timezone";
import { AiOutlineSearch } from "react-icons/ai";
import jsPDF from "jspdf";
import { FaDownload } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import { cloud_url_download } from "../../../Services/Configuration";
import { store } from "../../../App";
import { ExportToExcelButton, GetDetails, ModuleHeader } from "../../utils/commonFunctions";
import axiosTokenServiceKeyCloak from "../../../Services/axiosTokenServiceKeyCloak";
function BankSubsidry() {
  const [tableEnable, setTableEnable] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [headEnable, setHeadEnable] = useState(false);
  const [headTableData, setHeadTableData] = useState([]);

  const [bankNamesList, setBankNamesList] = useState();
  const [bal, setBal] = useState([]);
  const todayDate = new Date();
  const [creditSum, setCreditSum] = useState(0);
  const [debitSum, setDebitSum] = useState(0);
  const [searchText, setSearchText] = useState("");

  let year = todayDate.getUTCFullYear();

  let month = todayDate.getMonth() + 1;

  let tDate = todayDate.getDate();

  if (month < 10) {
    month = "0" + month;
  }
  if (tDate < 10) {
    tDate = "0" + tDate;
  }

  const maxDate = year + "-" + month + "-" + tDate;


  const handleSearch = (event) => {
    setSearchText(event.target.value);
  };
  const filteredData =
    searchText.length > 0
      ? tableData?.filter((item) => {
        return (
          item &&
          Object.keys(item).some((key) => {
            const value = item[key];
            return (
              value !== null &&
              value
                .toString()
                .toLowerCase()
                .includes(searchText.toLowerCase())
            );
          })
        );
      })
      : tableData;
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;
  const firstDayOfMonth = `${currentYear}-${currentMonth
    .toString()
    .padStart(2, "0")}-01`;
  const formik = useFormik({
    initialValues: {
      fromDate: firstDayOfMonth,
      toDate: today.toISOString().substr(0, 10),
      banknameaccountno: ""
    },
    validate: (values) => {
      const errors = {};
      if (!values.banknameaccountno) {
        errors.banknameaccountno = "Bank account number is required";
      }

      if (!values.fromDate) {
        errors.fromDate = "From Date is required";
      }
      if (!values.toDate) {
        errors.toDate = "To Date is required";
      }

      if (values.fromDate && values.toDate && values.fromDate > values.toDate) {
        errors.toDate = "To Date must be greater than From Date";
      }
      return errors;
    },

    onSubmit: (values) => {
      if (formik.isValid) {
        let params = { fromDate: moment(values.fromDate).format("DD/MM/YYYY"), toDate: moment(values.toDate).format("DD/MM/YYYY"), banknameaccountno: values.banknameaccountno };
        store.dispatch({ type: "SHOW_SPINNER" });
        HousingService.GetSubsidiary_Report(params).then((res) => {
          if (res.data && res.data.length > 0) {
            const tableData = res.data[0].cheque_dd_receipt_no === "null" && res.data[0].payment_receipt_id === "null" ? res.data.slice(1) : res.data;
            const totalsum = tableData.reduce(
              (acc, row) => {
                acc.totalDebit += Number(row.debit || 0);
                acc.totalCredit += Number(row.credit || 0);
                return acc;
              },
              { totalDebit: 0, totalCredit: 0 }
            );
            setCreditSum(totalsum.totalCredit);
            setDebitSum(totalsum.totalDebit);
            setTableData(tableData);
            setTableEnable(true);
            setHeadEnable(false);
          }
          else { setTableData([]); setTableEnable(false); setHeadEnable(true); }
        }).catch((error) => { console.log(error); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });

        let param = { fromDate: moment(values.fromDate).format("DD/MM/YYYY"), banknameaccountno: values.banknameaccountno }
        HousingService.getBankOpening_balance(param).then((res) => {
          if (res.data != null || res.data != undefined || res.data.length != 0) {
            setBal(res.data[0].opening_balance);
            console.log("opening_balance", res.data[0].opening_balance)
          }
        })
      }
    }
  });
  React.useEffect(() => {
    HousingService.fetchBank().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.banknameaccountno}>
              {item.banks}
            </option>
          );
        });
        setBankNamesList(options);
      }
    });
  }, []);


  const showNotification = (type, message) => {
    if (type === "success") {
      Swal.fire("Success", message, "success");
    } else if (type === "error") {
      Swal.fire("Error", message, "error");
    } else if (type === "warning") {
      Swal.fire("Warning", message, "warning");
    } else if (type === "info") {
      Swal.fire("info", message, "info");
    }
  };
  const [hiddenIcons, setHiddenIcons] = useState({});

  const fileDownload = (upload_copy, index) => {
    if (upload_copy == null) { showNotification("warning", "No File Uploaded"); } else {
      setHiddenIcons((prevHiddenIcons) => ({ ...prevHiddenIcons, [index]: true }));
      axiosTokenServiceKeyCloak({
        url: `${cloud_url_download}apofms/Pay_Rec&file=${encodeURIComponent(upload_copy)}`, method: "GET", responseType: "blob"
      })
        .then((response) => {
          const blob = new Blob([response.data], { type: response.headers["content-type"] });

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = upload_copy;

          link.click(); window.URL.revokeObjectURL(link.href); setHiddenIcons((prevHiddenIcons) => ({ ...prevHiddenIcons, [index]: false }));
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
          setHiddenIcons((prevHiddenIcons) => ({ ...prevHiddenIcons, [index]: false }));

          if (error.response && error.response.status === 500) {
            showNotification("error", "File Was Deleted, Upload the File Again");
          } else { showNotification("error", "An error occurred while downloading the file"); }
        });
    }
  };

  function GeneratePDF() {
    const pageWidth = 500; 
    const pageHeight = 250; 
    const imgPath = "/img/APSHCL_logo.png";
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [pageWidth, pageHeight]
    });
    const fromDate = moment(formik.values.fromDate).format("DD//MM/YYYY");
    const toDate = moment(formik.values.toDate).format("DD//MM/YYYY");
    const distuser = localStorage.getItem("username");
    const headingText2 =
      "Andhra Pradesh State Housing Corporation Limited (APSHCL)";
    const headingText3 = ` Bank Subsidary Report from : ${fromDate}  to : ${toDate} User: ${distuser} `;
    const headingText4 =
      "Nirman Bhavan, Plot No 11 & 12, Auto Nagar, Vijayawada, AP-520007";
    const fontSize = 12;
    const textWidth4 =
      (doc.getStringUnitWidth(headingText4) * fontSize) /
      doc.internal.scaleFactor;
    const xCoordinate4 = (pageWidth * 1 - textWidth4) / 2;

    doc.setFont("times new roman");

    const textWidth2 =
      (doc.getStringUnitWidth(headingText2) * fontSize) /
      doc.internal.scaleFactor;

    const textWidth3 =
      (doc.getStringUnitWidth(headingText3) * fontSize) /
      doc.internal.scaleFactor;

    const tableYStart = 35;

    doc.setFontSize(fontSize);

    const xCoordinate2 = (pageWidth * 1 - textWidth2) / 2;

    doc.text(headingText2, xCoordinate2, 10);
    const xCoordinate3 = (pageWidth * 1 - textWidth3) / 2;

    doc.text(headingText3, xCoordinate3, 30);
    doc.text(headingText4, xCoordinate4, 20);
    doc.addImage(imgPath, "PNG", 5, 5, 25, 25);

    doc.autoTable({
      html: "#my-table",
      theme: "grid",
      tableWidth: "auto",
      columnStyles: {
        3: { cellWidth: "wrap" }
      },
      startY: tableYStart,
      margin: { top: 5, right: 15, bottom: 5, left: 15 },
      styles: {
        fontSize: 8
      },
      columnWidth: { 0: 20, 1: 30, 2: 40 }
    });

    doc.save("BankSubsidary.pdf");
  }
  const headData = (payment_receipt_id) => {
    store.dispatch({ type: "SHOW_SPINNER" });
    setTableEnable(false);
    setHeadEnable(true);

    HousingService.GetHeadsTable(payment_receipt_id).then((res) => {
      setHeadTableData(res.data);

      store.dispatch({ type: "HIDE_SPINNER" });
    });
  };
  const backing = () => {
    setTableEnable(true);

    setHeadEnable(false);
  };
  return (
    <>
      <NavigationServicesHeader />
      <ModuleHeader title="Bank Subsidary" />
      <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <OFMSUI.Row>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} ></OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <th> From Date <span className="mandatory" style={{ color: "red" }}> * </span> </th>
                <Field name="fromDate" className={formik.touched.fromDate && formik.errors.fromDate ? "form-control is-invalid" : "form-control"} type="date" onChange={(e) => formik.handleChange(e)} />
                {formik.touched.fromDate && formik.errors.fromDate ? (<div className="invalid-feedback"> {formik.errors.fromDate} </div>) : null}
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <th> To Date <span className="mandatory" style={{ color: "red" }}> * </span> </th>

                <Field name="toDate" className={formik.touched.toDate && formik.errors.toDate ? "form-control is-invalid" : "form-control"} type="date" max={maxDate} onChange={(e) => formik.handleChange(e)} />
                {formik.touched.toDate && formik.errors.toDate ? (<div className="invalid-feedback">{formik.errors.toDate}</div>) : null}
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                <th> Name of the Bank <span className="mandatory" style={{ color: "red" }}> * </span> </th>

                <Field component="select" name="banknameaccountno" className={formik.touched.banknameaccountno && formik.errors.banknameaccountno ? "form-control is-invalid" : "form-control"} onChange={(e) => formik.handleChange(e)} >
                  {formik.touched.banknameaccountno && formik.errors.banknameaccountno ? (<div className="invalid-feedback"> {formik.errors.banknameaccountno} </div>) : null}
                  <option value="">--select--</option>
                  {bankNamesList}
                </Field>
              </OFMSUI.Col>
              <GetDetails />
            </OFMSUI.Row>
            &nbsp;
            <OFMSUI.Row className="mb-3"></OFMSUI.Row>
            <OFMSUI.Row>
              {tableEnable && (
                <>
                  <OFMSUI.Row>
                    <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3" >
                      <div className="input-group"> <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                        <input type="text" id="#filterInput" placeholder="Search" style={{ width: "25%" }} className="form-control input-lg" value={searchText} onChange={handleSearch} ></input>
                      </div>
                    </OFMSUI.Col>
                    <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className="mb-1" > <button type="button" className="btn btn-danger btn-sm" onClick={GeneratePDF} style={{ float: "right", color: "#fff", marginLeft: "1px", display: "flex", alignItems: "center", gap: "10px" }} > PDF <MdOutlinePictureAsPdf /> </button><ExportToExcelButton tableId="my-table" filename="BankSubsidary" sheet="tablexls" buttonText="Excel" />
                    </OFMSUI.Col>
                  </OFMSUI.Row>
                  <div style={{ overflow: "auto", height: "700px" }}>
                    <Table striped bordered hover id="my-table">
                      <thead className="fw-bold" style={{ position: "sticky", top: "0px" }} >
                        <tr> <td colSpan={12} style={{ textAlign: "center" }}> Opening Balance on &nbsp; {moment(formik.values.fromDate).format("DD-MM-YYYY")} &nbsp; for the Bank &nbsp; {formik.values.banknameaccountno} &nbsp; is Rs {parseFloat(bal).toFixed(2)} </td> </tr>
                        <tr className="table_countshead">
                          <th>S No.</th> <th>Date</th> <th className="text-center">Receipt No. / Voucher No.</th> <th>Recievied From/Paid To</th> <th>Payment Mode</th> <th>Inst Reference No.</th> <th>Particulars</th> <th>Head of Account</th> <th className="text-center">Debit</th> <th className="text-center">Credit</th> <th className="text-center">CB (Rs./-)</th> <th className="text-center">Download File</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData?.filter((element) => element.receiptno.toLowerCase().includes(searchText.toLowerCase())).length > 0 ? (filteredData.filter((element) =>
                          element.receiptno.toLowerCase().includes(searchText.toLowerCase())).map((tableData, index) => (
                            <tr key={index}>
                              <td>{1 + index}</td> <td>{moment(tableData.date).format("DD-MM-YYYY")}</td> <td style={{ width: "100px" }} className="text-right"> {tableData.receiptno} </td> <td>{tableData.name}</td> <td>{tableData.mode}</td> <td>{tableData.cheque_dd_receipt_no ? tableData.cheque_dd_receipt_no : "-"}</td> <td style={{ width: "500px" }}>{tableData.receipt_description}</td> <td onClick={() => headData(tableData.payment_receipt_id)}> <Link>{tableData.head_of_account}</Link> </td>
                              <td className="text-right">{parseFloat(tableData.debit).toFixed(2)}</td> <td className="text-right">{parseFloat(tableData.credit).toFixed(2)}</td> <td style={{ width: "100px" }} className="text-right"> {parseFloat(tableData.balance).toFixed(2)} </td>
                              <td className="text-center" style={{ fontSize: "21px", color: "green" }}> {!hiddenIcons[index] && (<FaDownload onClick={() => fileDownload(tableData.upload_copy, index)} />)} </td>
                            </tr>
                          ))
                        ) : (<tr> <td colSpan={12} style={{ textAlign: "center" }}> No Data Found </td> </tr>)}
                      </tbody>

                      <tfoot style={{ position: "sticky", bottom: "0px" }}>
                        <tr style={{ textAlign: "end" }} className="table_countshead" >
                          <td colSpan={8}>Total Amount in Rs/-</td> <td>{tableData?.reduce((a, v) => a + parseFloat(v.debit || 0), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                          <td>{tableData?.reduce((a, v) => a + parseFloat(v.credit || 0), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                          <td> {( parseFloat(bal || 0) + parseFloat(creditSum || 0) - parseFloat(debitSum || 0) ).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2, })} </td>
                          <td></td>
                        </tr>
                      </tfoot>
                    </Table>
                  </div>
                </>
              )}
              &nbsp;
              {headEnable && (
                <>
                  <button
                    className="btn btn-warning btn-sm"
                    type="button"
                    style={{ float: "left", width: "70px" }}
                    onClick={() => backing()}
                  >
                    Back
                  </button>
                  <center>
                    <h5
                      style={{
                        fontFamily: "times new roman",
                        color: "green"
                      }}
                    >
                      Bank Subsidary Head Details
                    </h5>
                  </center>
                  <Table striped bordered hover id="my-table" className="mb-5">
                    <thead className="fw-bold">
                      <tr className="table_countshead">
                        <th style={{ width: "5%" }}>S.no</th>
                        <th style={{ width: "45%" }}>Heads</th>
                        <th style={{ width: "45%" }}>SubHeads</th>
                        <th>Amount</th>
                      </tr>
                    </thead>

                    <tbody>
                      {headTableData?.map((headTableData, i) => (
                        <tr key={i}>
                          <td>{i + 1} </td>
                          <td>{headTableData.heads} </td>
                          <td>{headTableData.subheads}</td>
                          <td>{parseFloat(headTableData.amount).toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr className="table_countshead">
                        <td colSpan={3} style={{ textAlign: "end" }}>
                          Total Amount in Rs
                        </td>
                        <td>{headTableData?.reduce((a, v) => a + parseFloat(v.amount || 0), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      </tr>
                    </tfoot>
                  </Table>
                </>
              )}
            </OFMSUI.Row>
          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  );
}
export default BankSubsidry;